<template>
        <!-- parcel navi start -->
        <div class="bg-base-100 rounded-box p-1 border-base-content/5 border border-2 shadow floor-title-box">
            <div class="flex">
                <div class="flex flex-col items-start p-2" onClick="window.location.reload()">
                    <div class="text-primary font-bold">
                        {{ parcelTitle }}
                    </div>
                    <div class="text-base-content/80 font-bold text-xs">
                        {{ layerTitle }}
                    </div>
                </div> 
                <div class="divider divider-horizontal mx-0"></div>
                <div class="flex items-center" @click="goToMainMap">
                    <div class="btn btn-ghost p-1 mx-1">
                        <span class="material-symbols-outlined notranslate fill-current">
                            <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z"/></svg>
                        </span>
                    </div>
                </div>
            </div>

        </div> 
        <!-- parcel navi end -->
</template>

<script>

export default {
    props: {
        layerTitle: {
            type: String,
            required: true
        },
        parcelTitle: {
            type: String,
            required: true
        },
        goToMainMap: {
            type: Function,
            required: true
        },
        trans: {
            type: Object,
            required: true
        }
    }
};
</script>

<style></style>